import { formatForDateInput } from "../../helpers";

/**
 * Parse members data from server.
 * @param {array} members
 */
export function parseMembers(members) {
    return members.map((item) => {
        const { pivot, ...member } = item;
        return {
            birthday_sms: pivot.birthday_sms,
            include_in_report: pivot.include_in_report,
            is_active: pivot.is_active,
            is_leader: pivot.is_leader,
            join_date: formatForDateInput(pivot.join_date),
            member,
            role_id: pivot.role_id,
        };
    });
}
